<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <polygon
      style="stroke: #fff; stroke-width: 2px;"
      points="55.33 50.23 48.71 62.82 44.07 62.82 44.07 28.51 55.33 50.23"
    />
    <polygon
      style="stroke: #fff; stroke-width: 2px;"
      points="41.78 24.13 41.78 62.82 22.2 62.82 22.2 24.11 32 5.23 41.78 24.13"
    />
    <polygon
      style="stroke: #fff; stroke-width: 2px;"
      points="19.93 28.51 19.93 62.82 15.28 62.82 8.67 50.23 19.93 28.51"
    />
  </svg>
</template>

<script>
export default {
  name: 'CompassIcon',
};
</script>
